module.exports = __webpack_public_path__ + "img/Portafolio Patriot_2.c64847a5.png";